import type { MantineColorSchemeManager } from "@mantine/core";

import { clearPref, readPref, subscribePref, writePref } from "./prefs";

/**
 * Mantine's color scheme manager, stored through prefs.ts. Mantine's own default manager writes
 * to localStorage by itself, which would make prefs.ts no longer the only storage user (RC1).
 */
export function prefsColorSchemeManager(): MantineColorSchemeManager {
  let unsubscribe: (() => void) | undefined;
  return {
    get: () => readPref("colorScheme"),
    set: (value) => writePref("colorScheme", value),
    subscribe: (onUpdate) => {
      unsubscribe?.();
      unsubscribe = subscribePref("colorScheme", onUpdate);
    },
    unsubscribe: () => {
      unsubscribe?.();
      unsubscribe = undefined;
    },
    clear: () => clearPref("colorScheme"),
  };
}
